import { composeIO } from 'react-compose-io'
import { fieldsCondicaoIO } from './FieldsCondicao.IO'
import { FieldsCondicaoView } from './FieldsCondicao.View'

export const FieldsCondicao = composeIO(FieldsCondicaoView, fieldsCondicaoIO)
